import React, { useState, useRef, cloneElement, useEffect } from 'react';
import { cn } from '../../utils/cn';
import { Portal } from '../../utils/Portal';
import { useFloatingPosition } from '../../utils/useFloatingPosition';

export function Tooltip({ content, side = 'top', align = 'center', delay = 200, children, className }) {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const triggerRef = useRef(null);
  const floatingRef = useRef(null);

  const { style } = useFloatingPosition({ triggerRef, floatingRef, open, side, align, offset: 6 });

  const show = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setOpen(true), delay);
  };
  const hide = () => {
    clearTimeout(timer.current);
    setOpen(false);
  };

  useEffect(() => () => clearTimeout(timer.current), []);

  const child = cloneElement(children, {
    onMouseEnter: (e) => { show(); children.props.onMouseEnter?.(e); },
    onMouseLeave: (e) => { hide(); children.props.onMouseLeave?.(e); },
    onFocus:      (e) => { show(); children.props.onFocus?.(e); },
    onBlur:       (e) => { hide(); children.props.onBlur?.(e); },
    'aria-describedby': open ? 'ds-tooltip' : undefined,
  });

  return (
    <>
      <span ref={triggerRef} className="inline-block">
        {child}
      </span>
      {open && content && (
        <Portal>
          <span
            ref={floatingRef}
            id="ds-tooltip"
            role="tooltip"
            data-ds-theme="default"
            style={style}
            className={cn(
              'z-tooltip px-2 py-1 text-[11.5px] font-medium rounded-md shadow-md',
              'bg-ink text-cream whitespace-nowrap pointer-events-none',
              'animate-fade-in',
              className,
            )}
          >
            {content}
          </span>
        </Portal>
      )}
    </>
  );
}

export default Tooltip;
